import { compose } from 'redux';
import { connect } from 'react-redux';
import subscriptionDecorator from 'subscriptions/decorator';
import * as routes from 'app/routes';

import {
  getCurrentQuickPlan,
  getUpcomingQuickPlan,
  getCurrentQuickUsage,
  getAllQuickPlans,
  getOverduePurchases,
  getUser,
} from 'reducers';

import {
  fetchAll as fetchAllPlans,
} from 'subscriptions/plans/quick/actions';

import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/actions';

import { findCurrent as findCurrentUsage } from 'subscriptions/usage/quick/actions';
import { createQuickUpgrade as createUpgradePurchase } from 'billing/purchases/actions';
import AddDataPicker from './AddDataPicker';


const mapStateToProps = (state, { subId }) => ({
  upcomingPlan: getUpcomingQuickPlan(state, subId),
  currentPlan: getCurrentQuickPlan(state, subId),
  allPlans: getAllQuickPlans(state),
  usage: getCurrentQuickUsage(state, subId),
  overduePurchases: getOverduePurchases(state),
  user: getUser(state),
  isQuick: true,
});

const mapDispatchToProps = {
  fetchAllPlans,
  findCurrentUsage,
  createUpgradePurchase,
  purchaseRoute: routes.quickAddDataPurchase,
  fetchFilteredPurchases,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddDataPicker);
